import React, { Component }  from 'react'
import { connect } from 'react-redux'
import { List, AutoSizer } from 'react-virtualized'

import * as R from 'ramda'

import PropertyCard from './Card'
import { propertiesEx } from 'selectors/properties'
import { sortSev } from 'utils/stuff'

let select = (state) => ({
	properties: propertiesEx(state)
})

export class PropertiesList extends Component{
	render(){
		let properties = sortSev(this.props.properties, "status", "alias")
		return(
				<div
					className="properties-list"
					style={{
						width: "calc(100% - 55px)"
					  , height: "calc(100vh - 61px)"
					}}
				>
					<AutoSizer>
						{({ width, height }) => (
							<List
								width={width}
								height={height}
								rowCount={properties.length}
								rowHeight={86}
								overscanRowCount={10}
								rowRenderer={ ({
								  key,
								  index,
								  isScrolling,
								  isVisible,
								  style
								}) => {
									return (
										<PropertyCard
											id={properties[index]._id}
											style={style}
											detailID={this.props.detailID}
											key={key}
										/>
									)
								}}
							/>
						)}
					</AutoSizer>
				</div>
			)
	}
}
export default connect(select)(PropertiesList)



// WEBPACK FOOTER //
// ./src/routes/manager/properties/List.js